import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  SUBSCRIPTIONS_CREATE_CONTRACT_BEGIN,
  SUBSCRIPTIONS_CREATE_CONTRACT_SUCCESS,
  SUBSCRIPTIONS_CREATE_CONTRACT_FAILURE,
  SUBSCRIPTIONS_CREATE_CONTRACT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function createContract(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: SUBSCRIPTIONS_CREATE_CONTRACT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/subscriptions/contract/`,
        args,
        createAxiosConfigWithAuth(getState()),
      );

      doRequest.then(
        (res) => {
          dispatch({
            type: SUBSCRIPTIONS_CREATE_CONTRACT_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SUBSCRIPTIONS_CREATE_CONTRACT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateContractError() {
  return {
    type: SUBSCRIPTIONS_CREATE_CONTRACT_DISMISS_ERROR,
  };
}

export function useCreateContract() {
  const dispatch = useDispatch();

  const { createContractPending, createContractError } = useSelector(
    (state) => ({
      createContractPending: state.subscriptions.createContractPending,
      createContractError: state.subscriptions.createContractError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(createContract(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCreateContractError());
  }, [dispatch]);

  return {
    createContract: boundAction,
    createContractPending,
    createContractError,
    dismissCreateContractError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SUBSCRIPTIONS_CREATE_CONTRACT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createContractPending: true,
        createContractError: null,
      };

    case SUBSCRIPTIONS_CREATE_CONTRACT_SUCCESS:
      // The request is success
      return {
        ...state,
        createContractPending: false,
        createContractError: null,
      };

    case SUBSCRIPTIONS_CREATE_CONTRACT_FAILURE:
      // The request is failed
      return {
        ...state,
        createContractPending: false,
        createContractError: action.data.error,
      };

    case SUBSCRIPTIONS_CREATE_CONTRACT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createContractError: null,
      };

    default:
      return state;
  }
}
